export default __webpack_public_path__ + "static/2019_08-2d7e0f83add64afb138c1ba7d6598cc1.png";